import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { verificarUsuarioCadUnico } from '../../api/pessoaAPI';
import { obterUFs } from '../../api/recursosAPI';
import { RootState } from '../../app/store';
import * as mensagens from '../../common/Mensagens';
import { MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA, MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA_WEB } from '../../common/Mensagens';

export interface ConsultaCpfState {
  ufs: any[];
  cpf: any;
  dataNascimento: any;
  mensagem: string;
  tipoMensagem: string;
  ativarMensagem: boolean;
  passCode: string;
  temComunicacaoComAPI: boolean;
  mensagemVerificacaoUsuario: string;
  usuarioEncontrado: boolean;
  versaoMinimaAceitavel: boolean;
  situacaoCadastralPessoa: any;
  situacaoCadastralPrePessoa: any;
  informacaoPeriodoRetornoCadastramento: any;
  situacaoCadastralFamilia: any;
}

const initialState: ConsultaCpfState = {
  ufs: [],
  dataNascimento: '',
  cpf: '',
  mensagem: '',
  tipoMensagem: '',
  ativarMensagem: false,
  passCode: '',
  temComunicacaoComAPI: false,
  mensagemVerificacaoUsuario: '',
  usuarioEncontrado: false,
  versaoMinimaAceitavel: true,
  situacaoCadastralPessoa: '',
  situacaoCadastralPrePessoa: '',
  informacaoPeriodoRetornoCadastramento: '',
  situacaoCadastralFamilia: ''
};

export const getUfs = createAsyncThunk('consultaCpf/getUfs', async () => {
  return obterUFs();
});

export const verificarInfoUsuarioCadUnico = createAsyncThunk(
  'consultaCpf/getVerificarUsuarioCadUnico',
  async (dados: any) => {
    return verificarUsuarioCadUnico(dados);
  }
);
export const consultaCpfSlice = createSlice({
  name: 'consultaCpf',
  initialState,
  reducers: {
    alterarCpf: (state, action) => {
      state.cpf = action.payload;
    },
    alterarDataNascimento: (state, action) => {
      state.dataNascimento = action.payload;
    },
    ativarMensagem: (state, action) => {
      state.ativarMensagem = action.payload;
    },
    alterarMensagem: (state, action) => {
      state.mensagem = action.payload;
    },
    alterarTipoMensagem: (state, action) => {
      state.tipoMensagem = action.payload;
    },
    limpar: (state) => {
      state.cpf = initialState.cpf;
      state.dataNascimento = initialState.dataNascimento;
      state.mensagemVerificacaoUsuario = initialState.mensagemVerificacaoUsuario;
      state.usuarioEncontrado = initialState.usuarioEncontrado;
      state.situacaoCadastralPessoa = initialState.situacaoCadastralPessoa;
      state.situacaoCadastralPrePessoa = initialState.situacaoCadastralPrePessoa;
      state.situacaoCadastralFamilia = initialState.situacaoCadastralFamilia;
      state.informacaoPeriodoRetornoCadastramento = initialState.informacaoPeriodoRetornoCadastramento;
    },
    limparMensagemVerificacaoUsuario: (state) => {
      state.mensagemVerificacaoUsuario = initialState.mensagemVerificacaoUsuario;
    },
    atualizarPassCode: (state, action) => {
      state.passCode = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(getUfs.fulfilled, (state, action) => {
      state.ufs = action.payload;
      state.temComunicacaoComAPI = true;
    })
    .addCase(getUfs.rejected, (state, action) => {
      if (action.error?.message && (action.error?.message.includes(MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA) ||
        action.error?.message.includes(MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA_WEB))) {
        state.versaoMinimaAceitavel = false;
      }else{
        state.temComunicacaoComAPI = false;
      }
    })
    .addCase(verificarInfoUsuarioCadUnico.fulfilled, (state, action) => {
      state.ativarMensagem = false;
      state.mensagemVerificacaoUsuario = action.payload.mensagem;
      state.usuarioEncontrado = action.payload.usuarioCadUnico;
      state.situacaoCadastralPessoa = action.payload.situacaoCadastralPessoa;
      state.situacaoCadastralPrePessoa = action.payload.situacaoCadastralPrePessoa;
      state.situacaoCadastralFamilia = action.payload.situacaoCadastralFamilia;
      state.informacaoPeriodoRetornoCadastramento = action.payload.informacaoPeriodoRetornoCadastramento;
      state.passCode = initialState.passCode;
    })
    .addCase(verificarInfoUsuarioCadUnico.rejected, (state, error) => {
      state.ativarMensagem = true;
      state.tipoMensagem = 'warning';
      state.mensagemVerificacaoUsuario = initialState.mensagemVerificacaoUsuario;
      state.passCode = initialState.passCode;

      if (error.error.message === mensagens.MSG_ERRO_CAPTCHA_INVALIDO) {
        state.mensagem = mensagens.ERRO_AO_OBTER_RESPOSTA_CAPTCHA;
      } else {
        if (error.error.message === mensagens.MSG_TENTE_NOVAMENTE) {
          state.tipoMensagem = 'error';
          state.mensagem = mensagens.MSG_TENTE_NOVAMENTE;
        }else{
          state.mensagem = mensagens.MSG_CPF_NAO_ENCONTRADO;
        }

      }
    })
  },
});

export const {
  alterarDataNascimento,
  alterarCpf,
  ativarMensagem,
  alterarMensagem,
  alterarTipoMensagem,
  atualizarPassCode,
  limpar,
  limparMensagemVerificacaoUsuario

} = consultaCpfSlice.actions;

export const selectComunicacaoAPI = (state: RootState) => state.consultaCpf.temComunicacaoComAPI;
export const selectVersaoMinimaAceitavel = (state: RootState) => state.consultaCpf.versaoMinimaAceitavel;
export const selectUfs = (state: RootState) => state.consultaCpf.ufs;
export const selectState = (state: RootState) => state.consultaCpf;
export const selectPassCode = (state: RootState) => state.consultaCpf.passCode;


export default consultaCpfSlice.reducer;
